module.exports = __webpack_public_path__ + "img/01.ce2fefb3.jpg";